<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>This book is dedicated to the</i></p>
<p class="ded1"><i>interesting people doing research in life</i></p>
<p class="ded1"><i>extension, cryonics, and other such</i></p>
<p class="ded1"><i>intimations of immortality.</i></p>
<p class="ded1"><i>May you outlive your critics.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2ca5a4a6